/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactCursor = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M10 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM5 7a5 5 0 1 1 10 0A5 5 0 0 1 5 7zm8.293 6.293a1 1 0 0 1 .982-.254l7 2a1 1 0 0 1 .28 1.793l-1.985 1.323 2.637 2.638-1.414 1.414-2.638-2.637-1.323 1.985a1 1 0 0 1-1.793-.28l-2-7a1 1 0 0 1 .254-.982zm2.163 2.163.911 3.19.8-1.2a1 1 0 0 1 .278-.278l1.201-.8zm-10.137 2.02C4.436 18.328 4 19.541 4 21v1H2v-1c0-1.857.564-3.644 1.93-4.963C5.296 14.72 7.327 14 10 14c.373 0 .732.014 1.079.041l-.158 1.994A11.704 11.704 0 0 0 10 16c-2.326 0-3.795.622-4.68 1.476z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgContactCursor as ContactCursor };
